import React from "react";
import { Box, Typography, useTheme, useMediaQuery, Grid } from "@mui/material";
import Infotip from "../Tooltip";

interface Props {
  id: string,
  body: string[],
  image: string,
  imagePosition: 'left' | 'right',
  title: string,
  titleTooltip: string
}

const AboutPageSection = (props: Props) => {
  const { id, body, image, imagePosition, title, titleTooltip } = props;

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("lg"));
  const titleFontVariant = isSmallScreen ? "h4" : "h3";

  const imageEl = (
    <Box
      component="img"
      src={image}
      alt={`${id}`}
      m={3}
      sx={{ maxWidth: "90%", width: '100%', height: 'auto', borderRadius: '10%' }}
    />
  );

  const contentEl = (
    <Box sx={{ width: '100%', textAlign: 'center' }}>
      <Typography variant={titleFontVariant} component="h2" data-testid={`${id}-title`} pb={3} gutterBottom>
        {title}{' '}
        <Infotip title={titleTooltip}/>
      </Typography>
      {body.map((paragraph, idx) => (
        <Typography key={idx} variant='body1' fontSize={{ md: '1.4rem', xl: '2rem' }} gutterBottom>
          {paragraph}
        </Typography>
      ))}
    </Box>
  );

  if (isSmallScreen) {
    return (
      <Box id={id} mx={4} mt={2} display="flex" justifyContent="center" flexDirection="column" alignItems="center">
        {imageEl}
        {contentEl}
      </Box>
    );
  }

  const imageFirst = imagePosition === 'left';
  return (
    <Box id={id} mx={4} mt={2}>
      <Grid container spacing={3} alignItems="center" sx={{ maxWidth: 1200, mx: 'auto' }}>
        <Grid size={5} sx={{ order: imageFirst ? 1 : 2 }}>
          {imageEl}
        </Grid>
        <Grid size={7} sx={{ order: imageFirst ? 2 : 1, pl: imageFirst ? 3 : 0, pr: imageFirst ? 0 : 3 }}>
          {contentEl}
        </Grid>
      </Grid>
    </Box>
  );
};

export default AboutPageSection;
